export const FAQS = [
  {
    q: "How much does pressure washing cost in Colorado Springs?",
    a: "Residential power washing typically ranges from $150 to $750 depending on square footage and service type. Commercial jobs (lots, fleets, hoods) range from $300 to $3,000+. Use our instant quote calculator to get an exact price range in under a minute.",
  },
  {
    q: "What services does All Day Power Washing offer?",
    a: "We offer Power Washing, Concrete Cleaning, Gutter Cleaning, House Soft-Washing, Commercial Fleet & Heavy Equipment cleaning, and NFPA-96 Kitchen Hood Cleaning. Based in Colorado Springs; serving Colorado Springs, the Denver metro area, and surrounding states by request.",
  },
  {
    q: "Do you service Colorado Springs, Denver and beyond?",
    a: "Yes. All Day Power Washing is based in Colorado Springs and regularly services Colorado Springs, the Denver metro area (Aurora, Castle Rock, Parker, Highlands Ranch, Littleton), Monument, Fountain, and Pueblo. We also travel around Colorado by request and out to surrounding states (Wyoming, New Mexico, Kansas, Nebraska, Utah) for commercial jobs. Call or text 719-644-6105 to confirm coverage for your address.",
  },
  {
    q: "Are you licensed and insured?",
    a: "Yes. We are fully licensed and insured for both residential and commercial work. A certificate of insurance (COI) is available on request — common for property managers, HOAs, and commercial clients.",
  },
  {
    q: "How long does a typical power washing job take?",
    a: "A standard residential driveway takes 1–2 hours. A full house soft-wash runs 3–5 hours. Commercial lot cleanings typically complete overnight (4–8 hours). Exact duration is confirmed in your written quote.",
  },
  {
    q: "Can you remove oil stains from concrete?",
    a: "Yes. We use heavy-duty surface cleaners to lift oil, transmission fluid, and most organic stains from concrete. Most stains come out completely; severely set-in stains may lighten significantly but not disappear fully.",
  },
  {
    q: "Do you clean commercial fleets and heavy equipment?",
    a: "Yes. We clean trucks, trailers, box vans, construction equipment, and industrial machinery on-site. Monthly fleet maintenance contracts are available at discounted rates.",
  },
  {
    q: "Do you offer kitchen exhaust hood cleaning for restaurants?",
    a: "Yes. We perform NFPA-96 style exhaust hood and duct degreasing with compliance paperwork for health and fire inspectors. Scheduled quarterly or bi-annual contracts available.",
  },
  {
    q: "How soon can you start?",
    a: "Most quotes are scheduled within the same week. Emergency commercial jobs can often be dispatched within 24 hours. Call or text 719-644-6105 for urgent needs.",
  },
  {
    q: "What is your satisfaction guarantee?",
    a: "100% satisfaction. If any surface isn't cleaned to your expectation, we come back and make it right at no charge. No fine print, no upcharges.",
  },
  {
    q: "Do you use pressure washing or soft washing?",
    a: "Both — we match the method to the surface. Hard surfaces (concrete, brick, heavy equipment) get high-pressure cleaning. Delicate surfaces (siding, roofs, painted wood) get low-pressure soft-washing with mildewcide. Your quote specifies the method used.",
  },
  {
    q: "Is power washing safe for my house siding and windows?",
    a: "Yes — when done correctly. We use a soft-washing technique on siding and windows with low pressure and biodegradable detergent. We never use pressure settings that can strip paint or force water behind siding.",
  },
];
